module.exports = __webpack_public_path__ + "static/img/epidemic-8.9fb2b64.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/rescuelist/img/list/epidemic-8.png
// module id = 8MGF
// module chunks = 1